import { render, staticRenderFns } from "./carouselPage.vue?vue&type=template&id=57c8692d&scoped=true&"
import script from "./carouselPage.vue?vue&type=script&lang=js&"
export * from "./carouselPage.vue?vue&type=script&lang=js&"
import style0 from "./carouselPage.vue?vue&type=style&index=0&id=57c8692d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c8692d",
  null
  
)

export default component.exports